"use client";
import React from "react";
import { PinContainer } from "./ui/3d-pin";
import { OrbitingCirclesDemo } from "./OrbitingCircleSection";

export function AnimatedPinDemo() {
  return (
    <div className="h-[10rem] w-full flex items-center justify-center translate-y-[-1rem] sm:translate-y-0">
      <PinContainer title="Save resources with AI" href="https://quodata.de/form/contact-us?form=">
        <div className="flex basis-full flex-col lg:w-[20rem] w-[20rem] sm:h-[12rem] h-[10rem] ">
          <OrbitingCirclesDemo />
        </div>
      </PinContainer>
    </div>
  );
}
